module.exports = __webpack_public_path__ + "media/images/pvp-dd26b9f1db212b032e74a8a127d929bf.webp";